(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/iam-postmessage/assets/javascripts/iam-postmessage.js') >= 0) return;  svs.modules.push('/components/accountservices/iam-postmessage/assets/javascripts/iam-postmessage.js');

'use strict';

const _svs$accountservices$ = svs.accountservices.iamPostMessage,
  logger = _svs$accountservices$.logger,
  POST_MESSAGE_SOURCES = _svs$accountservices$.POST_MESSAGE_SOURCES,
  POST_MESSAGE_TYPES = _svs$accountservices$.POST_MESSAGE_TYPES;

const noopLogger = {
  debug: () => {},
  info: () => {},
  warn: () => {},
  error: () => {}
};

const createIframeUtils = function () {
  let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const IamIframeCommunication = svs.accountservices.iamPostMessage.IamIframeCommunication;
  const safeLogger = config.logger || logger || noopLogger;
  const iamComm = new IamIframeCommunication({
    source: config.source || POST_MESSAGE_SOURCES.IFRAME,
    logger: safeLogger
  });
  return {
    isInIamIframe: iamComm.isInsideIframe(),
    sendHeight: height => {
      iamComm.sendToParent({
        type: POST_MESSAGE_TYPES.HEIGHT,
        value: height
      });
    },
    redirectParent: (url, target) => {
      const value = target ? {
        url,
        target
      } : url;
      iamComm.sendToParent({
        type: POST_MESSAGE_TYPES.PARENT_REDIRECT,
        value
      });
    },
    showDialog: async (title, errorMessage, redirectUrl) => {
      try {
        await iamComm.sendToParentAndWait({
          type: POST_MESSAGE_TYPES.SHOW_DIALOG,
          value: {
            title,
            errorMessage,
            redirectUrl
          }
        }, POST_MESSAGE_TYPES.SHOW_DIALOG_RESOLVED, 0);
        return true;
      } catch (error) {
        safeLogger.error('Failed to show dialog in parent:', error);
        return false;
      }
    },
    showDialogExtended: async (title, message, icon, type, actions) => {
      try {
        const result = await iamComm.sendToParentAndWait({
          type: POST_MESSAGE_TYPES.SHOW_DIALOG_EXTENDED,
          value: {
            title,
            message,
            icon,
            type,
            actions
          }
        }, POST_MESSAGE_TYPES.SHOW_DIALOG_EXTENDED_RESOLVED, 0);
        return result;
      } catch (error) {
        safeLogger.error('Failed to show extended dialog in parent:', error);
        return 0;
      }
    },
    trackEvent: async trackingObject => {
      if (!iamComm.isInsideIframe()) {
        return new Promise(resolve => {
          svs.components.analytics.trackEvent(trackingObject, () => {
            resolve();
          });
        });
      }

      iamComm.sendToParentAndWait({
        type: POST_MESSAGE_TYPES.PARENT_TRACK_EVENT,
        value: trackingObject
      }, POST_MESSAGE_TYPES.PARENT_TRACK_EVENT_RESOLVED).catch(error => {
        safeLogger.warn('Failed to track event in parent, tracking locally:', error);
        svs.components.analytics.trackEvent(trackingObject);
      });
    },
    setFullscreen: () => {
      iamComm.sendToParent({
        type: POST_MESSAGE_TYPES.FULLSCREEN,
        value: true
      });
    },
    removeFullscreen: () => {
      iamComm.sendToParent({
        type: POST_MESSAGE_TYPES.REMOVE_FULLSCREEN,
        value: false
      });
    },
    getOnboardingData: async () => {
      try {
        const data = await iamComm.sendToParentAndWait({
          type: POST_MESSAGE_TYPES.GET_ONBOARDING_DATA,
          value: {}
        }, POST_MESSAGE_TYPES.GET_ONBOARDING_DATA);
        return data;
      } catch (error) {
        safeLogger.error('Failed to get onboarding data from parent:', error);
        return null;
      }
    },
    updateOnboardingData: async (onboardingData, onboardingUrls) => {
      try {
        const result = await iamComm.sendToParentAndWait({
          type: POST_MESSAGE_TYPES.UPDATE_ONBOARDING_DATA,
          value: {
            onboardingData,
            onboardingUrls
          }
        }, POST_MESSAGE_TYPES.PARENT_ONBOARDING_DATA_UPDATED);
        return result;
      } catch (error) {
        safeLogger.error('Failed to update onboarding data in parent:', error);
        return null;
      }
    },
    setLoginType: loginType => {
      iamComm.sendToParent({
        type: POST_MESSAGE_TYPES.SET_LOGIN_TYPE,
        value: loginType
      });
    },
    updateParentQuerystring: async (serializedLoginObject, isBankId) => {
      try {
        const querystring = await iamComm.sendToParentAndWait({
          type: POST_MESSAGE_TYPES.UPDATE_PARENT_QUERYSTRING,
          value: {
            serializedLoginObject,
            isBankId
          }
        }, POST_MESSAGE_TYPES.PARENT_QUERYSTRING_UPDATED);
        return querystring;
      } catch (error) {
        safeLogger.error('Failed to update parent querystring:', error);
        return null;
      }
    },
    getParentSlo: async () => {
      try {
        const slo = await iamComm.sendToParentAndWait({
          type: POST_MESSAGE_TYPES.GET_PARENT_SLO,
          value: {}
        }, POST_MESSAGE_TYPES.GOT_PARENT_SLO);
        return slo;
      } catch (error) {
        safeLogger.error('Failed to get parent SLO:', error);
        return null;
      }
    },
    deleteParentSlo: async () => {
      try {
        const deletedSlo = await iamComm.sendToParentAndWait({
          type: POST_MESSAGE_TYPES.DELETE_PARENT_SLO,
          value: {}
        }, POST_MESSAGE_TYPES.PARENT_SLO_DELETED);
        return deletedSlo;
      } catch (error) {
        safeLogger.error('Failed to delete parent SLO:', error);
        return null;
      }
    },
    listenToParent: callback => iamComm.listenToParent(callback),
    iamComm
  };
};

const setupParentCommunication = config => {
  const _config$iframeId = config.iframeId,
    iframeId = _config$iframeId === void 0 ? 'iamlogin-iframe' : _config$iframeId,
    _config$handlers = config.handlers,
    handlers = _config$handlers === void 0 ? {} : _config$handlers,
    _config$trustedRedire = config.trustedRedirectUrls,
    trustedRedirectUrls = _config$trustedRedire === void 0 ? [] : _config$trustedRedire;
  const safeLogger = config.logger || logger || noopLogger;
  const IamParentCommunication = svs.accountservices.iamPostMessage.IamParentCommunication;
  const iamParentComm = new IamParentCommunication({
    source: POST_MESSAGE_SOURCES.PARENT,
    iframeId,
    logger: safeLogger
  });

  const isTrustedRedirectUrl = url => trustedRedirectUrls.some(trustedUrl => url.startsWith(trustedUrl));

  iamParentComm.onMessage(POST_MESSAGE_TYPES.HEIGHT, (event, iframe) => {
    if (!iframe.classList.contains('iamlogin-iframe-fullscreen')) {
      var _event$data, _event$data2;
      iframe.style.height = (_event$data = event.data) !== null && _event$data !== void 0 && _event$data.value ? "".concat((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.value, "px") : 'auto';
    }
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.SHOW_DIALOG, async event => {
    var _event$data5, _event$data6;
    try {
      if (handlers.showDialog) {
        var _event$data3, _event$data4;
        await handlers.showDialog((_event$data3 = event.data) === null || _event$data3 === void 0 || (_event$data3 = _event$data3.value) === null || _event$data3 === void 0 ? void 0 : _event$data3.title, (_event$data4 = event.data) === null || _event$data4 === void 0 || (_event$data4 = _event$data4.value) === null || _event$data4 === void 0 ? void 0 : _event$data4.errorMessage);
      }
    } catch (error) {
      safeLogger.error('Error processing SHOW_DIALOG handler:', error);
    }
    const dialogResponsePayload = {
      source: POST_MESSAGE_SOURCES.PARENT,
      requestId: (_event$data5 = event.data) === null || _event$data5 === void 0 ? void 0 : _event$data5.requestId,
      messageType: POST_MESSAGE_TYPES.SHOW_DIALOG_RESOLVED
    };
    if (event.source) {
      event.source.postMessage(dialogResponsePayload, event.origin);
    } else {
      iamParentComm.sendToIframe(dialogResponsePayload, event.origin);
    }
    if ((_event$data6 = event.data) !== null && _event$data6 !== void 0 && (_event$data6 = _event$data6.value) !== null && _event$data6 !== void 0 && _event$data6.redirectUrl) {
      svs.utils.url.navigate(svs.utils.url.makeInternal(event.data.value.redirectUrl, svs.core.urlMapping.get('startPage')));
    }
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.SHOW_DIALOG_EXTENDED, async event => {
    var _event$data10, _event$data11;
    let resolvedValue = 0;
    try {
      if (handlers.showDialogExtended) {
        var _event$data7, _event$data8, _event$data9, _event$data0, _event$data1;
        resolvedValue = await handlers.showDialogExtended((_event$data7 = event.data) === null || _event$data7 === void 0 || (_event$data7 = _event$data7.value) === null || _event$data7 === void 0 ? void 0 : _event$data7.title, (_event$data8 = event.data) === null || _event$data8 === void 0 || (_event$data8 = _event$data8.value) === null || _event$data8 === void 0 ? void 0 : _event$data8.message, (_event$data9 = event.data) === null || _event$data9 === void 0 || (_event$data9 = _event$data9.value) === null || _event$data9 === void 0 ? void 0 : _event$data9.icon, (_event$data0 = event.data) === null || _event$data0 === void 0 || (_event$data0 = _event$data0.value) === null || _event$data0 === void 0 ? void 0 : _event$data0.type, (_event$data1 = event.data) === null || _event$data1 === void 0 || (_event$data1 = _event$data1.value) === null || _event$data1 === void 0 ? void 0 : _event$data1.actions);
      }
    } catch (error) {
      safeLogger.error('Error processing SHOW_DIALOG_EXTENDED handler:', error);
    }
    const extDialogResponsePayload = {
      source: POST_MESSAGE_SOURCES.PARENT,
      requestId: (_event$data10 = event.data) === null || _event$data10 === void 0 ? void 0 : _event$data10.requestId,
      messageType: POST_MESSAGE_TYPES.SHOW_DIALOG_EXTENDED_RESOLVED,
      value: resolvedValue
    };
    if (event.source) {
      event.source.postMessage(extDialogResponsePayload, event.origin);
    } else {
      iamParentComm.sendToIframe(extDialogResponsePayload, event.origin);
    }
    if ((_event$data11 = event.data) !== null && _event$data11 !== void 0 && (_event$data11 = _event$data11.value) !== null && _event$data11 !== void 0 && _event$data11.redirectUrl) {
      svs.utils.url.navigate(svs.utils.url.makeInternal(event.data.value.redirectUrl, svs.core.urlMapping.get('startPage')));
    }
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.PARENT_REDIRECT, event => {
    var _event$data12, _event$data14, _event$data15;
    let navigateUrl;
    let target;
    if (typeof ((_event$data12 = event.data) === null || _event$data12 === void 0 ? void 0 : _event$data12.value) === 'string') {
      var _event$data13;
      navigateUrl = (_event$data13 = event.data) === null || _event$data13 === void 0 ? void 0 : _event$data13.value;
    } else if (typeof ((_event$data14 = event.data) === null || _event$data14 === void 0 ? void 0 : _event$data14.value) === 'object' && ((_event$data15 = event.data) === null || _event$data15 === void 0 ? void 0 : _event$data15.value) !== null) {
      var _event$data16, _event$data17;
      target = (_event$data16 = event.data) === null || _event$data16 === void 0 || (_event$data16 = _event$data16.value) === null || _event$data16 === void 0 ? void 0 : _event$data16.target;
      navigateUrl = (_event$data17 = event.data) === null || _event$data17 === void 0 || (_event$data17 = _event$data17.value) === null || _event$data17 === void 0 ? void 0 : _event$data17.url;
    }
    if (!isTrustedRedirectUrl(navigateUrl)) {
      navigateUrl = svs.utils.url.makeInternal(navigateUrl, svs.core.urlMapping.get('startPage'));
    }
    if (target && typeof target === 'string' && target.trim() !== '') {
      window.open(navigateUrl, target);
    } else {
      svs.utils.url.navigate(navigateUrl);
    }
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.GET_ONBOARDING_DATA, async event => {
    var _event$data18, _theme;
    if (!((_event$data18 = event.data) !== null && _event$data18 !== void 0 && _event$data18.requestId)) return;
    let extraData, theme, state, cancelUrl, returnUrl, isReturnNewCustomer;
    try {
      if (handlers.getOnboardingData) {
        extraData = await handlers.getOnboardingData();
      }
      if (handlers.getTheme && extraData) {
        var _extraData, _extraData$toLowerCas;
        theme = handlers.getTheme(((_extraData = extraData) === null || _extraData === void 0 || (_extraData = _extraData.branding) === null || _extraData === void 0 || (_extraData$toLowerCas = _extraData.toLowerCase) === null || _extraData$toLowerCas === void 0 ? void 0 : _extraData$toLowerCas.call(_extraData)) || '');
      }
      if (handlers.getState) {
        state = handlers.getState();
        cancelUrl = state.cancelUrl;
        returnUrl = state.returnUrl;
        isReturnNewCustomer = state.isReturnNewCustomer;
      }
    } catch (error) {
      safeLogger.error('Error processing GET_ONBOARDING_DATA handlers:', error);
    }
    const onboardingResponsePayload = {
      source: POST_MESSAGE_SOURCES.PARENT,
      requestId: event.data.requestId,
      messageType: POST_MESSAGE_TYPES.GET_ONBOARDING_DATA,
      value: {
        extraData,
        cancelUrl,
        returnUrl,
        isReturnNewCustomer,
        theme,
        product: ((_theme = theme) === null || _theme === void 0 ? void 0 : _theme.branding) || 'tur-100'
      }
    };
    if (event.source) {
      event.source.postMessage(onboardingResponsePayload, event.origin);
    } else {
      iamParentComm.sendToIframe(onboardingResponsePayload, event.origin);
    }
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.FULLSCREEN, (event, iframe) => {
    iframe.classList.add('iamlogin-iframe-fullscreen');
    iframe.style.height = '100%';
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.REMOVE_FULLSCREEN, (event, iframe) => {
    iframe.classList.remove('iamlogin-iframe-fullscreen');
    iframe.style.height = '';
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.UPDATE_ONBOARDING_DATA, async event => {
    var _event$data19;
    if (!((_event$data19 = event.data) !== null && _event$data19 !== void 0 && _event$data19.requestId)) return;
    let updatedOnboardingData = null;
    try {
      if (handlers.updateOnboardingData) {
        var _event$data20;
        updatedOnboardingData = await handlers.updateOnboardingData(((_event$data20 = event.data) === null || _event$data20 === void 0 || (_event$data20 = _event$data20.value) === null || _event$data20 === void 0 ? void 0 : _event$data20.onboardingData) || {});
      }
      if (handlers.updateOnboardingUrls) {
        var _event$data21;
        await handlers.updateOnboardingUrls(((_event$data21 = event.data) === null || _event$data21 === void 0 || (_event$data21 = _event$data21.value) === null || _event$data21 === void 0 ? void 0 : _event$data21.onboardingUrls) || {});
      }
    } catch (error) {
      safeLogger.error('Error processing UPDATE_ONBOARDING_DATA handlers:', error);
    }

    const updateResponsePayload = {
      source: POST_MESSAGE_SOURCES.PARENT,
      requestId: event.data.requestId,
      messageType: POST_MESSAGE_TYPES.PARENT_ONBOARDING_DATA_UPDATED,
      value: updatedOnboardingData
    };
    if (event.source) {
      event.source.postMessage(updateResponsePayload, event.origin);
    } else {
      iamParentComm.sendToIframe(updateResponsePayload, event.origin);
    }
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.SET_LOGIN_TYPE, async event => {
    if (handlers.setLoginType) {
      var _event$data22;
      await handlers.setLoginType(((_event$data22 = event.data) === null || _event$data22 === void 0 ? void 0 : _event$data22.value) || 'BANKID');
    }
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.UPDATE_PARENT_QUERYSTRING, async event => {
    var _event$data23;
    if (!((_event$data23 = event.data) !== null && _event$data23 !== void 0 && _event$data23.requestId)) return;
    let parentQuerystring = null;
    try {
      if (handlers.getReturnUrlForEidApp) {
        var _event$data24;
        const _ref = ((_event$data24 = event.data) === null || _event$data24 === void 0 ? void 0 : _event$data24.value) || {},
          serializedLoginObject = _ref.serializedLoginObject,
          isBankId = _ref.isBankId;
        parentQuerystring = handlers.getReturnUrlForEidApp(serializedLoginObject, isBankId);
      }
    } catch (error) {
      safeLogger.error('Error processing UPDATE_PARENT_QUERYSTRING handler:', error);
    }
    const qsResponsePayload = {
      source: POST_MESSAGE_SOURCES.PARENT,
      requestId: event.data.requestId,
      messageType: POST_MESSAGE_TYPES.PARENT_QUERYSTRING_UPDATED,
      value: parentQuerystring
    };
    if (event.source) {
      event.source.postMessage(qsResponsePayload, event.origin);
    } else {
      iamParentComm.sendToIframe(qsResponsePayload, event.origin);
    }
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.GET_PARENT_SLO, async event => {
    var _event$data25;
    if (!((_event$data25 = event.data) !== null && _event$data25 !== void 0 && _event$data25.requestId)) return;
    let parentSlo = null;
    try {
      if (handlers.getParentSlo) {
        parentSlo = handlers.getParentSlo();
      }
    } catch (error) {
      safeLogger.error('Error processing GET_PARENT_SLO handler:', error);
    }
    const sloResponsePayload = {
      source: POST_MESSAGE_SOURCES.PARENT,
      requestId: event.data.requestId,
      messageType: POST_MESSAGE_TYPES.GOT_PARENT_SLO,
      value: parentSlo
    };
    if (event.source) {
      event.source.postMessage(sloResponsePayload, event.origin);
    } else {
      iamParentComm.sendToIframe(sloResponsePayload, event.origin);
    }
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.DELETE_PARENT_SLO, async event => {
    var _event$data26;
    if (!((_event$data26 = event.data) !== null && _event$data26 !== void 0 && _event$data26.requestId)) return;
    let deletedParentSlo = null;
    try {
      if (handlers.deleteParentSlo) {
        deletedParentSlo = handlers.deleteParentSlo();
      }
    } catch (error) {
      safeLogger.error('Error processing DELETE_PARENT_SLO handler:', error);
    }
    const deleteSloResponsePayload = {
      source: POST_MESSAGE_SOURCES.PARENT,
      requestId: event.data.requestId,
      messageType: POST_MESSAGE_TYPES.PARENT_SLO_DELETED,
      value: deletedParentSlo
    };
    if (event.source) {
      event.source.postMessage(deleteSloResponsePayload, event.origin);
    } else {
      iamParentComm.sendToIframe(deleteSloResponsePayload, event.origin);
    }
  });

  iamParentComm.onMessage(POST_MESSAGE_TYPES.PARENT_TRACK_EVENT, async event => {
    var _event$data27;
    if (!((_event$data27 = event.data) !== null && _event$data27 !== void 0 && _event$data27.requestId)) return;
    if (handlers.trackEvent) {
      var _event$data28;
      await handlers.trackEvent(((_event$data28 = event.data) === null || _event$data28 === void 0 ? void 0 : _event$data28.value) || {});
    }

    const responsePayload = {
      source: POST_MESSAGE_SOURCES.PARENT,
      requestId: event.data.requestId,
      messageType: POST_MESSAGE_TYPES.PARENT_TRACK_EVENT_RESOLVED
    };
    if (event.source) {
      event.source.postMessage(responsePayload, event.origin);
    } else {
      iamParentComm.sendToIframe(responsePayload, event.origin);
    }
  });

  const stopListening = iamParentComm.listen(POST_MESSAGE_SOURCES.IFRAME);
  return {
    iamParentComm,
    stopListening
  };
};

Object.assign(svs.accountservices.iamPostMessage, {
  createIframeUtils,
  setupParentCommunication
});

 })(window);